import {
    Bundle,
    BundleType,
    Release,
    SiteCredentials,
} from '@myrtls/api-interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import {
    createSiteDeploymentBundleSuccessAction,
    createSiteTemplatesFailureAction,
    createSiteTemplatesRequestAction,
    createSiteTemplatesSuccessAction,
    downloadSiteDeploymentAction,
    downloadSiteDeploymentFailureAction,
    downloadSiteDeploymentSuccessAction,
    getCredentialsSuccessAction,
    getSiteDeploymentBundlesSuccessAction,
    getSiteReleasesAction,
    getSiteReleasesFailureAction,
    getSiteReleasesSuccessAction,
    getVersionSuccessAction,
} from './deployment.actions';
import { selectSiteAction } from '../sites/sites.actions';

export interface DeploymentState {
    deploymentBundles: { [key in BundleType]?: Bundle[] };
    releases: Release[];
    releasesLoading: boolean;
    downloadingDeployment: boolean;
    creatingTemplates: boolean;
    version: string | null;
    credentials: SiteCredentials | null;
}

const initialState: DeploymentState = {
    deploymentBundles: {},
    releases: [],
    releasesLoading: false,
    downloadingDeployment: false,
    creatingTemplates: false,
    version: null,
    credentials: null,
};

const reducer = createReducer(
    initialState,
    on(getVersionSuccessAction, (state, { version }) => ({
        ...state,
        version,
    })),
    on(getSiteReleasesAction, state => ({
        ...state,
        releases: [],
        releasesLoading: true,
    })),
    on(getSiteReleasesSuccessAction, (state, { releases }) => ({
        ...state,
        releases,
        releasesLoading: false,
    })),
    on(getSiteReleasesFailureAction, state => ({
        ...state,
        releasesLoading: false,
    })),
    on(
        getSiteDeploymentBundlesSuccessAction,
        (state, { bundles, bundleType }) => {
            return {
                ...state,
                deploymentBundles: {
                    ...state.deploymentBundles,
                    [bundleType]: bundles,
                },
            };
        },
    ),
    on(createSiteDeploymentBundleSuccessAction, (state, { bundle }) => ({
        ...state,
        deploymentBundles: {
            ...state.deploymentBundles,
            [bundle.type]: [bundle],
        },
    })),
    on(downloadSiteDeploymentAction, state => ({
        ...state,
        downloadingDeployment: true,
    })),
    on(downloadSiteDeploymentSuccessAction, state => ({
        ...state,
        downloadingDeployment: false,
    })),
    on(downloadSiteDeploymentFailureAction, state => ({
        ...state,
        downloadingDeployment: false,
    })),
    on(createSiteTemplatesRequestAction, state => ({
        ...state,
        creatingTemplates: true,
    })),
    on(createSiteTemplatesSuccessAction, state => ({
        ...state,
        creatingTemplates: false,
    })),
    on(createSiteTemplatesFailureAction, state => ({
        ...state,
        creatingTemplates: false,
    })),
    on(selectSiteAction, state => ({
        ...state,
        credentials: null,
    })),
    on(getCredentialsSuccessAction, (state, { credentials }) => ({
        ...state,
        credentials,
    })),
);

export function deploymentReducer(
    state: DeploymentState | undefined,
    action: Action,
): DeploymentState {
    return reducer(state, action);
}
